export default __webpack_public_path__ + "static/media/nft logo 1.92127aac.svg";